export const BONUS_GAME_SPECIAL_HITS_THRESHOLD_FOR_NEXT_LEVEL_V1 = {
  NORMAL: [
    Number.NEGATIVE_INFINITY, 31, 80, 185, 375, 750, 1600, 3200, Number.POSITIVE_INFINITY,
  ],
  HARD: [
    Number.NEGATIVE_INFINITY, 9, 55, 163, 356, 725, 1600, 3200, Number.POSITIVE_INFINITY,
  ]
}

// v2 REDESIGNED (maxLevel 13). Special-hit thresholds to advance L2->L3 ... L12->L13.
// Verified by full 10M enumeration:
//   NORMAL: RTP 96.40% / max 5748x / CV 8.6 (bins = BIN_MULTIPLIERS as-is).
//   HARD:   these thresholds + NORMAL bins give base RTP 92.17% / max 5747x; the deliverable HARD
//           economy scales payouts x1.043 -> RTP 96.13% / max 5994x / CV 15.6 (bonus-only, main=0).
export const BONUS_GAME_SPECIAL_HITS_THRESHOLD_FOR_NEXT_LEVEL_V2 = {
  NORMAL: [
    Number.NEGATIVE_INFINITY, 29, 76, 164, 335, 669, 1328, 2646, 5262, 10460, 20780, 41341, Number.POSITIVE_INFINITY
  ],
  HARD: [
    Number.NEGATIVE_INFINITY, 21, 65, 151, 320, 660, 1329, 2656, 5286, 10503, 20863, 41459, Number.POSITIVE_INFINITY
  ]
}

export const BLINKO_GAME_CONFIG_CID_V1 = '0x69a9f7a58f1688cca6f4c2a61df9f9fcc2c7ed8104a848009e2b58f73a3b7e98';
export const BLINKO_HARD_MODE_CONFIG_CID_V1 = '0x24b547e7e92127f3857350d5f99d3af5f052f90089d53053dedc9aa657a33367';
export const BLINKO_GAME_CONFIG_CID_V2 = '0xf12774adb82657baf43708a48dbba5cac7799ead8e5dca7cc8b43fb3b75a8903';
export const BLINKO_HARD_MODE_CONFIG_CID_V2 = '0x0d0cc9cdd3fa69e7a868629d06495a7c3aeb9a586990357acffa29463e605360';
